import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from './locales/en/translation.json';
import deTranslation from './locales/de/translation.json';

const userLocale = navigator.language || 'en-US'; // Detect user's browser locale
const germanLocales = ['de-DE', 'de-AT', 'de-CH', 'de-LU', 'de-LI']; // Define German-speaking country codes
const defaultLanguage = germanLocales.includes(userLocale) ? 'de' : 'en'; // Set default language based on user locale

i18n
  .use(initReactI18next) // Initializes i18n for use with React
  .init({
    lng: defaultLanguage,
    fallbackLng: 'en', // The default language to fall back on if a translation is missing
    debug: process.env.NODE_ENV === 'development', // Enables debug logging in npm start only (the tests run with NODE_ENV test, and the log would print both translation files at every start)
    resources: {
      en: {
        translation: enTranslation,
      },
      de: {
        translation: deTranslation,
      },
    },
    interpolation: {
      escapeValue: false, // Allows you to use HTML tags in translation strings
    },
  });

export default i18n;
